import { useEffect } from "react";

export const useIntersectionObserver = (callback, once = true, delay = 2000) => {
    useEffect(() => {
        if (!("IntersectionObserver" in window)) {
            return () => {};
        }

        const observerItem = document.querySelectorAll(".observer-item");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.reverse().forEach((entry) => {
                    if (entry.isIntersecting > 0) {
                        const sectionTitle = entry.target.dataset?.observerName;
                        const sectionType = entry.target.dataset?.observerType;

                        if (sectionTitle || sectionType) {
                            callback({ sectionTitle, sectionType });
                        } else {
                            console.warn(
                                ".observer-item is missing a data-observer-name attribute"
                            );
                        }
                        if (once) observer.unobserve(entry.target);
                    }
                });
            },
            {
                // eslint-disable-next-line object-shorthand
                delay: delay,
                threshold: 0,
                trackVisibility: true,
                rootMargin: "-50%"
            }
        );

        observerItem.forEach((el) => {
            observer.observe(el);
        });

        // cleanup when the component is removed from the dom
        return () => {
            observerItem.forEach((el) => {
                observer.unobserve(el);
            });
        };
    }, []);
};
